import React from 'react';
import HomeFloorBox from './home-floor-box';
import CarCards from './car-card';
import {useRef, useState, useEffect} from 'react';
import {HomeGameCardItem} from '@/pages/home/home.type';

interface HomeFloorCarProps {
  name: string;
  id: string;
  games: HomeGameCardItem[];
  serverTime?: number;
  shown?: boolean;
  categoryPic?: string;
}

const HomeFloorCar = ({
  name,
  categoryPic,
  games = [],
  serverTime,
  id,
  shown = true,
}: HomeFloorCarProps) => {
  const timer = useRef<NodeJS.Timeout>();
  const currentRef = useRef(0);
  const [currentTime, setCurrentTime] = useState(0);

  useEffect(() => {
    if (serverTime && serverTime > 0) {
      startRemaining(serverTime);
    }
  }, [serverTime]);

  const startRemaining = (time = 0) => {
    timer.current && clearInterval(timer.current);
    currentRef.current = time;
    setCurrentTime(currentRef.current);
    timer.current = setInterval(() => {
      currentRef.current = currentRef.current + 1000;
      setCurrentTime(currentRef.current);
    }, 1000);
  };

  useEffect(() => {
    return () => {
      timer.current && clearInterval(timer.current);
    };
  }, []);

  return (
    <HomeFloorBox
      id={id}
      gameType={'car'}
      name={name}
      shown={shown}
      categoryPic={categoryPic}>
      <div className="flex flex-row overflow-auto gap-2">
        {games.map((item, _i) => (
          <CarCards
            key={_i}
            i={_i}
            v={item}
            serverTime={serverTime}
            currentTime={currentTime}
          />
        ))}
      </div>
    </HomeFloorBox>
  );
};

export default HomeFloorCar;
